import { useState } from "react";
import { IMagazineCategory } from "../entity/magazineCategory/IMagazineCategory";
import { useNavigate } from "react-router-dom";
import { deleteMagazineCategoryUseCase } from "../useCases/deleteMagazineCategoryUseCase";
import { toastService } from "src/libraries/toast";
import { useUiContext } from "src/UIProvider";

export const useMagazineCategoriesTableItem = (item: IMagazineCategory) => {
    const { t } = useUiContext();
    const [open, setOpen] = useState(null);
    const navigate = useNavigate();

    const onOpenMenu = (event) => {
        setOpen(event.currentTarget);
    };

    const onCloseMenu = () => {
        setOpen(null);
    };

    const onDelete = async () => {
        const result: any = await deleteMagazineCategoryUseCase(item.id);
        if (!result?.isError) {
            toastService.onSuccess(t('magazineCategory.message.magazineCategoryRemoved'));
        } 
    };

    const onEdit = () => {
        navigate('/dashboard/magazine-categories/edit/' + item.id);
    };

    return { open, onOpenMenu, onCloseMenu, onDelete, onEdit }
}